import * as React from 'react';

const LogoutIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
        <path
            stroke="#8B8AA8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 28H6.667A2.667 2.667 0 0 1 4 25.333V6.667A2.667 2.667 0 0 1 6.667 4H12M21.334 22.666 28.001 16l-6.667-6.667M28 16H12"
        />
    </svg>
);
export default LogoutIcon;
